import { c as _c } from "react/compiler-runtime";
import type { TelecollectionModel } from "../../domain/models/Telecollection";
import type { SearchFilter, SearchInclude, SearchSort } from "../../domain/models/http/SearchRequest";
import { telecollectionQuery } from "../../services/payments/TelecollectionQueryService";
import { queryKeys } from "@/utils/queryKeys";
import useCustomPaginateQuery from "./useCustomPaginateQuery";
const TELECOLLECTION_INCLUDES: SearchInclude[] = [{
  relation: "plaque"
}, {
  relation: "site"
}, {
  relation: "subsidiary"
}];
const DEFAULT_SORT: SearchSort[] = [{
  field: "transaction_at",
  direction: "desc"
}];
type UseTelecollectionsParams = {
  filters?: SearchFilter[];
  sorts?: SearchSort[];
  page: number;
  limit: number;
  enabled?: boolean;
};
export const useTelecollections = t0 => {
  const $ = _c(16);
  const {
    filters: t1,
    sorts,
    page,
    limit,
    enabled: t2
  } = t0;
  let enabled;
  let filters;
  let t3;
  let t4;
  if ($[0] !== limit || $[1] !== page || $[2] !== sorts || $[3] !== t1 || $[4] !== t2) {
    filters = t1 === undefined ? [] : t1;
    enabled = t2 === undefined ? true : t2;
    t4 = useCustomPaginateQuery;
    t3 = queryKeys.payments.telecollections({
      filters,
      sorts,
      page,
      limit
    });
    $[0] = limit;
    $[1] = page;
    $[2] = sorts;
    $[3] = t1;
    $[4] = t2;
    $[5] = enabled;
    $[6] = filters;
    $[7] = t3;
    $[8] = t4;
  } else {
    enabled = $[5];
    filters = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  const t5 = sorts && sorts.length > 0 ? sorts : DEFAULT_SORT;
  let t6;
  if ($[9] !== enabled || $[10] !== filters || $[11] !== limit || $[12] !== page || $[13] !== t3 || $[14] !== t5) {
    t6 = {
      queryKey: t3,
      request: telecollectionQuery,
      includes: TELECOLLECTION_INCLUDES,
      filters,
      sorts: t5,
      page,
      limit,
      enabled
    };
    $[9] = enabled;
    $[10] = filters;
    $[11] = limit;
    $[12] = page;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t4(t6);
};